import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import alert from '@/helpers/alert'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    leaseList: [],
    selectedLease: {},
    loading: false,
  },
  getters: {
    getAll(state) {
      return state.leaseList
    },
    getSelectedLease(state) {
      return state.selectedLease
    },
  },
  mutations: {
    setLeaseList(state, data) {
        state.leaseList = data
    },
    updateLease(state, data) {
      state.leaseList.forEach((lease) => {
        if (lease.id === data.id) {
          Object.assign(lease, data)
        }
      });
      if (state.selectedLease.id === data.id) {
        Object.assign(state.selectedLease, data)
      }
      console.log({selectedLease: state.selectedLease, data} )
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setSelectedLease(state, lease) {
      state.selectedLease = lease
    },
    deleteLease(state, leaseId) {
      state.leaseList.forEach((lease, index) => {
        if (lease.id === leaseId) {
          state.leaseList.splice(index, 1)
        }
      })
      if (leaseId === state.selectedLease.id) {
        state.selectedLease = {}
      }
    },
    updateTenants(state, tenants) {
      Vue.set(state.selectedLease, 'tenants', tenants)
    },
    deleteTenant(state, id) {
      state.selectedLease.tenants.forEach((tenant, index) => {
        if (tenant.id === id) {
          state.selectedLease.tenants.splice(index, 1)
        }
      })
    },
    updateTenantFile(state, file) {
      state.selectedLease.tenants.forEach((tenant, index) => {
        if (file.tenant_id === tenant.id) {
          tenant.files.push(file)
        }
      })
    },
  },
  actions: {
    /**
     * Gets all lease address for the logged in customer
     *
     * @param Object context
     */
    async fetch(context) {
      const url = config.apiBaseUrl + 'lease'
      try {
        const response = await axios.get(url)
        if (response.data.data.length > 0) {
          context.commit('setLeaseList', response.data.data)
        } else {
          if (response.data.errmsg !== '') {
            alert.error(response.data.errmsg)
          }
        }
      } catch (error) {
        alert.error(error)
      }
    },
    /**
     * Gets the lease based on ID
     *
     * @param Object context
     * @param Object id Lease ID
     */
    async fetchLease(context, id) {
      const url = config.apiBaseUrl + 'lease/get'

      try {
        const response = await axios.get(url, { params: { id: id } })

        if (response.data.data) {
          const lease = response.data.data
          if (lease.rental_rate !== '') {
            lease.rental_rate = (lease.rental_rate * 100).toFixed(1)
          }
          context.commit('setSelectedLease', lease)
        } else {
          if (response.data.errmsg !== '') {
            alert.error(response.data.errmsg)
          }
        }
      } catch (error) {
        alert.error(error)
      }
    },
    // /**
    //  * Handles updating lease data
    //  * TODO: Once the issue with updating a new lease is fixed
    //  * this function has to update the lease in `houseList`
    //  *
    //  * @param Object context
    //  * @param Object lease
    //  */
    async updateLease(context, data) {
      try {
        const patchData = {...data};
        delete patchData.task;
        const response = await axios.patch(config.apiBaseUrl + 'lease', patchData)
        let lease = data

        if (response.data.errno === 0) {
          lease.id = response.data.data.id
          context.commit('updateLease', lease)
          alert.success('Lease updated successfully')
        } else {
          alert.error(response.data.errmsg)
        }
      } catch (error) {
        alert.error(error)
      }
    },

    /**
     * Deletes the lease from user's account
     *
     * @param Object context
     * @param Number leaseId    Lease ID
     */
    async deleteLease(context, leaseId) {
      const url = config.apiBaseUrl + 'lease/delete'

      try {
        const response = await axios.post(url, { id: leaseId, })
        if (response.data.errmsg === '') {
          context.commit('deleteLease', leaseId)
          alert.success('Successfully deleted lease')
        } else {
          alert.error(response.errmsg)
        }
      } catch (error) {
        alert.error(error)
      }
    },

    async sendNotification(context, emailContent) {
      const url = config.apiBaseUrl + 'issue/email'

      try {
        const response = await axios.post(url, emailContent)

        if (response.data.errmsg === '') {
          alert.success('Successfully sent')
        } else {
          alert.error(response.errmsg)
        }
      } catch (error) {
        alert.error(error)
      }
    },

    getActiveLease({state}, house_id) {
      const today = moment().format('YYYY-MM-DD');
      let leases = state.leaseList.filter(lease => lease.house_id === house_id);
      leases = leases.filter(lease => lease.checkin_date <= today && lease.checkout_date >= today);
      if (!leases || leases.length === 0) {
        return null;
      }
      return leases[0]
    }

  },
}
